import request from '@/utils/request'

export function approvalItemsProcess () {
  return request({
    url: '/amrep/approval/itemsProcess',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/approval.js